/* nano Popup "Zahnbürsten-Check" – Frontend-Logik.
 * Ablauf: Frage -> personalisierte Reaktion + E-Mail -> Code.
 * Speicherung: localStorage (Anzeige-Frequenz), n8n-Webhook (E-Mail, Antwort, Code). */
(function () {
  'use strict';
  var root = document.getElementById('nano-popup');
  var teaser = document.getElementById('nano-popup-teaser');
  if (!root) return;

  var KEY = 'nanoPopup.v1';
  var cfg = {
    webhook: root.getAttribute('data-webhook') || '',
    delay: parseInt(root.getAttribute('data-delay'), 10) || 20,
    exitIntent: root.getAttribute('data-exit-intent') === 'true',
    reshowDays: parseInt(root.getAttribute('data-reshow-days'), 10) || 14,
    fallbackCode: root.getAttribute('data-discount-code-fallback') || ''
  };

  // Reaktionstexte je Antwort (Schritt 2)
  var REACTIONS = {
    '1 Monat': {
      kicker: 'Respekt',
      title: 'Du bist auf Zahnarzt-Niveau.',
      text: 'Nur wenige wechseln so konsequent. Damit das so bleibt, ohne dass du dran denken musst, gibt es ein Dankeschön von uns.'
    },
    '2 Monate': {
      kicker: 'Solide',
      title: 'Alle zwei Monate, das schaffen die wenigsten.',
      text: 'Frische Borsten reinigen spürbar gründlicher. Für deinen nächsten Wechsel haben wir etwas für dich.'
    },
    '3 Monate': {
      kicker: 'Genau richtig',
      title: 'Alle drei Monate ist die Empfehlung.',
      text: 'Länger sollten Borsten nicht im Einsatz sein, danach lässt die Reinigung nach. Zeit für Nachschub? Wir helfen mit.'
    },
    'Länger als 3 Monate': {
      kicker: 'Danke für die Ehrlichkeit',
      title: 'Das geht fast allen so.',
      text: 'Zahnärzt:innen empfehlen den Wechsel alle drei Monate, denn abgenutzte Borsten putzen schlechter und reizen das Zahnfleisch. Ein guter Moment, um neu zu starten.'
    }
  };

  // ---- State -------------------------------------------------------------
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) { /* privat/blockiert: egal */ } }
  var state = load();

  function shouldAutoShow() {
    if (state.converted) return false;
    if (state.dismissedAt && Date.now() - state.dismissedAt < cfg.reshowDays * 864e5) return false;
    if (location.pathname.indexOf('/checkouts') === 0 || location.pathname.indexOf('/cart') === 0) return false;
    return true;
  }

  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event };
    for (var k in (data || {})) payload[k] = data[k];
    window.dataLayer.push(payload);
  }

  // ---- UI-Helfer ---------------------------------------------------------
  var steps = root.querySelectorAll('[data-np-step]');
  var answer = null, lastFocus = null, opened = false;

  function goTo(n) {
    root.setAttribute('data-step', String(n));
    for (var i = 0; i < steps.length; i++) {
      var s = steps[i], active = s.getAttribute('data-np-step') === String(n);
      s.hidden = !active;
      s.classList.toggle('is-active', active);
    }
    var focusTarget = root.querySelector('[data-np-step="' + n + '"] input, [data-np-step="' + n + '"] .np__answer, [data-np-step="' + n + '"] .np__btn');
    if (focusTarget && n !== 1) setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 50);
  }

  function open(source) {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    if (teaser) teaser.hidden = true;
    document.documentElement.classList.add('np-lock');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    goTo(state.converted ? 3 : (answer ? 2 : 1));
    track('nano_popup_view', { popup_source: source || 'timer' });
  }

  function close(reason) {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    document.documentElement.classList.remove('np-lock');
    setTimeout(function () { root.hidden = true; }, 300);
    if (!state.converted) {
      state.dismissedAt = Date.now();
      save(state);
      if (teaser) teaser.hidden = false;
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    track('nano_popup_close', { popup_reason: reason || 'button', popup_step: root.getAttribute('data-step') });
  }

  // ---- Schritt 1: Antwort ------------------------------------------------
  var answerBtns = root.querySelectorAll('[data-np-answer]');
  Array.prototype.forEach.call(answerBtns, function (btn) {
    btn.addEventListener('click', function () {
      answer = btn.getAttribute('data-np-answer');
      Array.prototype.forEach.call(answerBtns, function (b) { b.classList.toggle('is-selected', b === btn); });
      var r = REACTIONS[answer] || REACTIONS['3 Monate'];
      root.querySelector('[data-np-reaction-kicker]').textContent = r.kicker;
      root.querySelector('[data-np-reaction-title]').textContent = r.title;
      root.querySelector('[data-np-reaction-text]').textContent = r.text;
      track('nano_popup_answer', { toothbrush_change: answer });
      setTimeout(function () { goTo(2); }, 220);
    });
  });

  // ---- Schritt 2: Absenden -----------------------------------------------
  var form = root.querySelector('[data-np-form]');
  var emailInput = root.querySelector('#np-email');
  var errorEl = root.querySelector('[data-np-error]');
  var submitBtn = root.querySelector('[data-np-submit]');

  function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; emailInput.classList.add('is-invalid'); }
  function clearError() { errorEl.hidden = true; emailInput.classList.remove('is-invalid'); }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v); }

  // Enter im Feld: explizit absenden (implizite Submission ist nicht in jedem Kontext zuverlaessig).
  emailInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); if (form.requestSubmit) form.requestSubmit(); else submitBtn.click(); }
  });

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    clearError();
    var email = (emailInput.value || '').trim();
    if (!validEmail(email)) { showError('Bitte gib eine gültige E-Mail-Adresse ein.'); emailInput.focus(); return; }
    if (!cfg.webhook) { showError('Anmeldung gerade nicht möglich. Bitte später erneut versuchen.'); return; }

    submitBtn.disabled = true; submitBtn.classList.add('is-loading');
    var payload = {
      email: email,
      toothbrush_change: answer || '',
      hp: form.querySelector('[name="hp"]').value || '',
      source: 'popup-zahnbuersten-check',
      page: location.pathname,
      referrer: document.referrer || '',
      consent_text: root.querySelector('.np__legal').textContent.trim(),
      ts: new Date().toISOString()
    };
    var timeout = new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, 9000); });
    var req = fetch(cfg.webhook, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { j._status = r.status; return j; }); });

    Promise.race([req, timeout]).then(function (res) {
      if (!res || res.ok !== true) throw new Error(res && res.error ? res.error : 'server');
      onSuccess(res.code || cfg.fallbackCode, res.code ? 'unique' : 'fallback');
    }).catch(function (err) {
      // n8n nicht erreichbar / Fehler: E-Mail ist ggf. dennoch angekommen -> mit Fallback-Code weiter,
      // sonst mit Hinweis "Code per E-Mail", damit niemand ohne Ergebnis dasteht.
      if (cfg.fallbackCode) { onSuccess(cfg.fallbackCode, 'fallback-error'); return; }
      onSuccess('', 'email-only');
      track('nano_popup_error', { popup_error: String(err && err.message || err) });
    }).then(function () {
      submitBtn.disabled = false; submitBtn.classList.remove('is-loading');
    });
  });

  // ---- Schritt 3: Code ---------------------------------------------------
  var codeValue = root.querySelector('[data-np-code-value]');
  var codeBtn = root.querySelector('[data-np-copy]');
  var codeText = root.querySelector('[data-np-code-text]');
  var codeHint = root.querySelector('[data-np-code-hint]');

  function onSuccess(code, mode) {
    state.converted = true; state.code = code; state.convertedAt = Date.now();
    save(state);
    if (code) {
      codeValue.textContent = code;
      applyDiscount(code);
    } else {
      codeBtn.hidden = true;
      codeText.textContent = 'Dein Code ist unterwegs und landet in wenigen Minuten in deinem Postfach.';
      codeHint.hidden = true;
    }
    goTo(3);
    track('nano_popup_signup', { popup_code_mode: mode, toothbrush_change: answer || '' });
    // Klaviyo Onsite-Tracking: Profil im Browser identifizieren (fuer Viewed-Product-Events etc.)
    try { window.klaviyo = window.klaviyo || []; window.klaviyo.push(['identify', { email: emailInput.value.trim() }]); } catch (e) {}
  }

  function applyDiscount(code) {
    // Shopify legt den Code ueber /discount/CODE als Cookie in die Session; kein Reload noetig.
    try { fetch('/discount/' + encodeURIComponent(code) + '?redirect=/', { credentials: 'same-origin', redirect: 'follow' }).catch(function () {}); } catch (e) {}
  }

  codeBtn.addEventListener('click', function () {
    var code = codeValue.textContent;
    var done = function () {
      codeBtn.classList.add('is-copied');
      root.querySelector('[data-np-copy-label]').textContent = 'Kopiert ✓';
      setTimeout(function () { codeBtn.classList.remove('is-copied'); root.querySelector('[data-np-copy-label]').textContent = 'Kopieren'; }, 2200);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else { var r = document.createRange(); r.selectNodeContents(codeValue); var sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); try { document.execCommand('copy'); } catch (e) {} done(); }
  });
  root.querySelector('[data-np-shop]').addEventListener('click', function () { close('shop'); });

  // ---- Schließen ---------------------------------------------------------
  Array.prototype.forEach.call(root.querySelectorAll('[data-np-close]'), function (el) {
    el.addEventListener('click', function () { close(el.classList.contains('np__overlay') ? 'overlay' : 'button'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && opened) close('escape'); });
  if (teaser) teaser.addEventListener('click', function () { open('teaser'); });

  // ---- Trigger -----------------------------------------------------------
  if (state.converted) {
    // Bereits angemeldet: nichts anzeigen, Code bei Bedarf still erneut anwenden.
    if (state.code) applyDiscount(state.code);
    return;
  }
  if (!shouldAutoShow()) { if (teaser && state.dismissedAt) teaser.hidden = false; return; }

  var timer = setTimeout(function () { open('timer'); }, cfg.delay * 1000);
  if (cfg.exitIntent && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', function onOut(e) {
      if (e.relatedTarget || e.clientY > 10) return;
      document.removeEventListener('mouseout', onOut);
      clearTimeout(timer);
      open('exit-intent');
    });
  }
})();
